export enum VALIDATION_MESSAGE {
  AGENT_NAME_MESSAGE = 'Please enter a name',
  AGENT_ACCESS_MESSAGE = 'Please select a role',
  AGENT_EMPLOYEE_ID_MESSAGE = 'Please enter an employee ID',
  PHONE_NUMBER_MESSAGE = 'Please enter a valid 10 digit phone number',
  NAVI_EMAIL_MESSAGE = 'Please enter a valid Navi email address',
  EMAIL_MESSAGE = 'Please enter a valid email address',
  REPORTING_MANAGER_MESSAGE = 'Please select a reporting manager',
  AGENCY_CODE_MESSAGE = 'Please select an agency code',
  BUCKET_GROUP_MESSAGE = 'Please select a bucket group',
  AGENCY_CENTRE_MESSAGE = 'Please select an agency centre',
  AGENT_STATE_MESSAGE = 'Please select an agent state',
  PRIMARY_LANGUAGE_MESSAGE = 'Please select a primary language',
  PRIMARY_REGION_MESSAGE = 'Please select a primary region',
  LATITUDE_LONGITUDE_MESSAGE = 'Please enter a valid lat/long',
  DATE_OF_BIRTH_MESSAGE = 'Please select date of birth',
  PAN_CARD_MESSAGE = 'Please enter a valid PAN',
  PAN_CARD_STATUS_APPROVED = 'PAN verified successfully',
  PAN_CARD_STATUS_PENDING = 'PAN verification in progress',
  PAN_CARD_STATUS_INVALIDATED = 'Invalidated: Re upload for verification',
  PAN_CARD_STATUS_REJCETED = 'Rejected: Re upload for verification'
}

export enum VERIFICATION_MESSAGE {
  MISMATCHED_CITY = 'The above city differs from co-ordinates below',
  MISMATCHED_PINCODE = 'The above pincode differs from co-ordinates below',
  MISMATCHED_CITY_LOCATION = 'The above co-ordinates does not belong to city you’ve selected',
  MISMATCHED_PINCODE_LOCATION = 'The above co-ordinates does not belong to pincode you’ve entered',
  UNVERIFIED_LOCATION = 'Please verify in order to proceed further',
  VERIFICATION_IN_PROGRESS = 'Verification in progress, please wait...'
}

export const defaultValues = {
  agentName: '',
  phoneNumber: '',
  emailAddress: '',
  roles: [],
  active: 'true',
  employeeId: '',
  reportingManagerEmailAddress: '',
  state: '',
  agencyCodeRequested: '',
  primaryLanguage: '',
  secondaryLanguage: '',
  tertiaryLanguage: '',
  extraLanguages: [],
  bucketGroup: '',
  reportingManagerReferenceId: '',
  agentCenter: '',
  currentMonthLatitude: '',
  currentMonthLongitude: '',
  nextMonthLatitude: '',
  nextMonthLongitude: '',
  agentCity: '',
  topAgent: '',
  currentMonthAgentPincode: '',
  nextMonthAgentPincode: '',
  agentType: '',
  activeNextMonth: 'true',
  dateOfBirth: '',
  panNumber: '',
  isTrainingAgent: true
};

export const NAVI_AGENCY_CODE = '1000';

export enum VERIFICATION_STATUS {
  UNVERIFIED = 'UNVERIFIED',
  IN_PROGRESS = 'IN_PROGRESS',
  VERIFIED = 'VERIFIED',
  APPROVED = 'APPROVED'
}

export enum AGENT_TYPE {
  INHOUSE = 'INHOUSE',
  EXTERNAL = 'EXTERNAL'
}

export const AGENT_BANDWIDTH_OPTIONS = [
  {
    id: 'shared',
    label: 'Shared',
    value: 'SHARED'
  },
  {
    id: 'dedicated',
    label: 'Dedicated',
    value: 'DEDICATED'
  }
];

export const TOP_AGENT_OPTIONS = [
  {
    id: 'yes',
    label: 'Yes',
    value: 'TOP'
  },
  {
    id: 'no',
    label: 'No',
    value: 'NONE'
  },
  {
    id: 'neutral',
    label: 'Neutral',
    value: 'NEUTRAL'
  }
];

export const ACTIVE_NEXT_MONTH_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

export enum ENTITY_TYPE {
  CITY = 'city',
  PINCODE = 'pincode'
}

export interface StatusMap {
  validationMessage: string;
  icon: React.ReactElement;
}

export enum NUMBER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
